export default "__VITE_ASSET__BTmHVkCD__"